<template>
	<fieldset class="_form-select-field" :name="name">
		<Layout :error="displayErrors && !valid">
			<template #index>{{ formatInteger(Number(index), 2) }}.</template>
			<template #label>
				<legend>{{ label }}</legend>
			</template>
			<template #input>
				<ul class="options -p-large">
					<li v-for="(option, i) in options" :key="i">
						<label class="relative">
							<input ref="options" class="hide-input" type="checkbox" :value="option" @input="onInput" />
							<div class="tick relative"></div>
							<div class="label no-select">{{ option }}</div>
							<div class="line-divider absolute left-0 bottom-0" />
						</label>
					</li>
				</ul>
			</template>
		</Layout>
	</fieldset>
</template>

<script>
import Layout from './Layout'
import { formatInteger } from '@/helpers/strings'

export default {
	components: { Layout },
	inject: ['$form'],
	props: {
		index: { type: [Number, String], default: 1 },
		type: { type: String, required: true },
		name: { type: String, required: true },
		label: { type: String, required: true },
		options: { type: Array, required: true },
		multiple: { type: Boolean, default: false },
		displayErrors: { type: Boolean, default: false },
	},
	data() {
		return {
			value: undefined,
			valid: false,
		}
	},
	methods: {
		formatInteger,
		onInput({ target }) {
			const optionInputs = Array.isArray(this.$refs.options)
				? this.$refs.options
				: this.$refs.options
					? [this.$refs.options]
					: []

			if (!this.multiple) {
				optionInputs.forEach((input) => (input.checked = input.value === target.value))
				target.checked = true
			}

			const selected = optionInputs.filter((input) => input.checked).map((input) => input.value)

			this.value = this.multiple ? selected : selected[0]
			this.valid = selected.length > 0

			this.$form?.setField(this.name, {
				value: this.value,
				valid: this.valid,
			})
		},
	},
}
</script>

<style lang="scss">
._form fieldset:last-of-type._form-select-field .options > li:last-child .line-divider {
	display: block;
}

._form-select-field .options > li:last-child .line-divider {
	display: none;
}

._form-select-field {
	position: relative;

	@include min-width($xs) {
		._form-field-layout .g-col:last-child {
			padding-top: 0;
		}
	}

	label {
		display: flex;
		align-items: center;
		gap: rs(16, 10);
		padding: rs(10, 10) 0;

		cursor: pointer;

		.tick {
			width: rs(20, 20);
			height: rs(20, 20);

			border: 1px solid var(--color);
			border-radius: 100%;
			overflow: hidden;

			&:after {
				content: '';
				position: absolute;
				inset: 0;

				border-radius: inherit;
				background-color: var(--color);

				transform: scale(0);
				transition: transform 0.4s ease('m3.emphasized', 'accelerate');
				will-change: transform;
			}
		}

		@include hover {
			.tick:after {
				transform: scale(0.33);
				transition-timing-function: ease('m3.emphasized', 'decelerate');
			}
		}

		input[type='checkbox']:checked + .tick:after {
			transform: scale(1);
			transition-timing-function: ease('m3.emphasized', 'decelerate');
		}

		input[type='checkbox']:focus-visible + .tick {
			box-shadow: 0 0 0 3px rgba($black, 0.3);
		}
	}
}
</style>
